import { Controller } from "@hotwired/stimulus"

// /avis-patients: criterion filters and pagination swap the list with a GET Turbo Stream
// (ReviewsController#index + push_state). Dims the list while loading, brings its top
// back into view after a swap, and reloads on back/forward since only the list changed.
export default class extends Controller {
  static targets = ["list"]

  connect () {
    this.popstateHandler = () => window.location.reload()
    window.addEventListener("popstate", this.popstateHandler)
  }

  disconnect () {
    window.removeEventListener("popstate", this.popstateHandler)
  }

  loading () {
    if (this.hasListTarget) this.listTarget.setAttribute("aria-busy", "true")
  }

  listTargetConnected (element) {
    // The first list is the one rendered with the page: leave the scroll position alone.
    if (!this.swapped) {
      this.swapped = true
      return
    }

    if (element.getBoundingClientRect().top < 0) {
      element.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
}
